import { render, staticRenderFns } from "./calibrationLabChangePassword.vue?vue&type=template&id=070ce182&scoped=true&"
import script from "./calibrationLabChangePassword.vue?vue&type=script&lang=js&"
export * from "./calibrationLabChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./calibrationLabChangePassword.vue?vue&type=style&index=0&id=070ce182&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070ce182",
  null
  
)

export default component.exports